import axios from "axios";

export default axios.create({
  baseURL: "https://online.geniuspolska.pl",
  responseType: "json",
});
